import { nextTick, defineAsyncComponent } from "vue";
import { getI18n, registerEntityEndpoint, getClient } from "@editor/ui-utils";
const de = {
  articlePushApi: {
    createAlreadyExists: "ArticlePush kann nicht erstellt werden, da bereits ein ArticlePush mit diesem Namen existiert",
    updateAlreadyExists: "ArticlePush kann nicht aktualisiert werden, da bereits ein ArticlePush mit diesem Namen existiert",
    created: "ArticlePush erstellt",
    updated: "ArticlePush aktualisiert",
    notFound: "ArticlePush nicht gefunden",
    requiredFields: "Sie können den ArticlePush nicht speichern, da obligatorische Informationen fehlen"
  },
  articlePushList: {
    newButton: "Neues ArticlePush",
    name: "Nach Push-Hauptzeile oder Channel suchen",
    deleteArticlePush: "Löschen",
    dpAny: "Alle",
    brand: "Marke",
    loading: "Lade ArticlePush",
    headerLabel: "Bezeichnung",
    headerCreatedAt: "Erstellt am",
    headerChangedAt: "Geändert am",
    counter: "Zähler",
    dpEdit: "Bearbeiten",
    dpView: "Anzeigen",
    messageDeleted: "Nachricht gelöscht",
    errorOnDeleting: "Fehler beim Löschen",
    createArticlePush: "ArticlePush erstellen",
    goToArticle: "Zum Artikel",
    editArticle: "Bearbeiten",
    title: "Push-Hauptzeile",
    status: "Status",
    kickerTitle: "Kicker, Title",
    channel: "Channel",
    headerPublished: "Veröffentlichungsdatum",
    pushed: "Gepusht am",
    pushedBy: "Gepusht von"
  },
  articlePush: {
    articlePushLabel: "ArticlePush",
    backButton: "Zurück zur ArticlePush-Liste",
    newArticlePush: "Neues ArticlePush",
    messageDeleteArticlePush: "ArticlePush löschen",
    messageDeleteArticlePushTitle: "Sind Sie sicher, dass Sie dieses ArticlePush löschen möchten?",
    deleteArticlePush: "Löschen",
    messageDeleted: "ArticlePush gelöscht",
    errorOnDeleting: "Es gab einen Fehler beim Löschen des ArticlePushs",
    errorFailedLoadedArticlePushWithId: "Es gab einen Fehler beim Abrufen des ArticlePushs",
    messageSaved: "Der Artikel wurde erfolgreich gepusht",
    pushKicker: "Push-Vorzeile",
    pushHeadline: "Push-Hauptzeile",
    channel: "Channel",
    pushNotification: "Pushen",
    savePush: "Speichern und pushen",
    publishPush: "Veröffentlichen und pushen",
    push: "Pushen",
    pushAndBanner: "PUSHEN(+BANNER)",
    articlePushAlreadySent: "Dieser Artikel wurde bereits am {date} Uhr gepusht.",
    breakingNewsCheckbox: "Eilmeldung"
  },
  banner: {
    tabLabel: "Banner",
    requiredFields: "Du kannst das Banner mit ungültigen Daten nicht speichern",
    expiresAtMessage: "Das Banner wird um {time} (in {inMinutes} Minuten) am {date} deaktiviert.",
    expiredMessage: "Das Banner wurde um {time} am {date} deaktiviert.",
    expireInputLabel: "Dauer ab Speicherzeitpunkt (in Minuten)",
    headlineInputLabel: "Banner-Zeile",
    stopBannerButton: "BANNER STOPPEN",
    states: {
      active: "Aktiv",
      notVisible: "Nicht sichtbar",
      expired: "Abgelaufen"
    }
  },
  articlePushEdit: {
    label: "Bezeichnung",
    counter: "Zähler",
    goToPage: "auf der Seite",
    backButton: "Zurück zur ArticlePush-Liste",
    editArticlePush: "ArticlePush bearbeiten",
    pushNotification: "Push notification",
    messageSaved: "Der Artikel wurde erfolgreich gepusht"
  }
};
const en = {
  articlePushApi: {
    createAlreadyExists: "Can't create ArticlePush because another ArticlePush with this name already exists",
    updateAlreadyExists: "Can't update ArticlePush because another ArticlePush with this name already exists",
    created: "ArticlePush created",
    updated: "ArticlePush updated",
    notFound: "ArticlePush not found",
    requiredFields: "You can't save the ArticlePush because mandatory information is missing"
  },
  articlePushList: {
    newButton: "New ArticlePush",
    name: "Search by title or channel",
    deleteArticlePush: "Delete",
    dpAny: "All",
    brand: "Brand",
    loading: "Loading ArticlePush",
    headerLabel: "Label",
    headerCreatedAt: "Created at",
    headerChangedAt: "Changed at",
    counter: "Counter",
    dpEdit: "Edit",
    dpView: "View",
    messageDeleted: "Message deleted",
    errorOnDeleting: "Error on deleting",
    createArticlePush: "Create ArticlePush",
    goToArticle: "Go to article",
    editArticle: "Edit article",
    title: "Title",
    status: "Status",
    kickerTitle: "Kicker, Title",
    channel: "Channel",
    headerPublished: "Published at",
    pushed: "Pushed",
    pushedBy: "Pushed by"
  },
  articlePush: {
    articlePushLabel: "ArticlePush",
    backButton: "Back to ArticlePush list",
    newArticlePush: "New ArticlePush",
    messageDeleteArticlePush: "Delete ArticlePush",
    messageDeleteArticlePushTitle: "Are you sure you want to delete this ArticlePush?",
    deleteArticlePush: "Delete",
    messageDeleted: "ArticlePush Deleted",
    errorOnDeleting: "There was an error deleting the ArticlePush ",
    errorFailedLoadedArticlePushWithId: "There was an error getting the ArticlePush",
    messageSaved: "Article was successfully pushed",
    pushKicker: "Push kicker",
    pushHeadline: "Push headline",
    channel: "Channel",
    pushNotification: "Push notification",
    savePush: "Save & Push",
    publishPush: "Publish & Push",
    push: "Push",
    pushAndBanner: "PUSH (+ BANNER)",
    articlePushAlreadySent: "Push notification for this article was already sent on {date}.",
    breakingNewsCheckbox: "Breaking news"
  },
  banner: {
    tabLabel: "Banner",
    requiredFields: "You can't save Banner with invalid data",
    expiresAtMessage: "The banner will be deactivated at {time} (in {inMinutes} minutes) on {date}.",
    expiredMessage: "The banner was deactivated at {time} on {date}.",
    expireInputLabel: "Duration from saving (in minutes)",
    headlineInputLabel: "Banner headline",
    stopBannerButton: "STOP BANNER",
    states: {
      active: "Active",
      notVisible: "Not visible",
      expired: "Expired"
    }
  },
  articlePushEdit: {
    label: "Label",
    counter: "Counter",
    goToPage: "To the page",
    backButton: "Back to ArticlePush list",
    editArticlePush: "Edit ArticlePush",
    pushNotification: "Push notification",
    messageSaved: "Article was successfully pushed"
  }
};
const messages = { en, de };
const ARTICLE_PUSH_ROUTE = "/article-push";
const routes = [
  {
    path: ARTICLE_PUSH_ROUTE,
    meta: { i18RouteTitleKey: "article-push" },
    children: [
      {
        path: "",
        name: "article_push_list",
        component: () => import("./article-push-list.view-CzpdFFbw.js"),
        meta: { requiredRight: "navigate_list_article_push" }
      },
      {
        path: "new",
        name: "article_push_new",
        component: () => import("./article-push-edit.view-D4u1yl4L.js"),
        props: () => ({
          title: getI18n().t("articlePush.newArticlePush"),
          backRoute: "/article-push"
        }),
        meta: { requiredRight: ["navigate_article_push"] }
      },
      {
        path: ":id",
        name: "article_push_detail",
        component: () => import("./article-push-edit.view-D4u1yl4L.js"),
        props: (route) => ({
          title: getI18n().t("articlePushEdit.editArticlePush"),
          id: route.params.id,
          backRoute: "/article-push"
        }),
        meta: { requiredRight: ["navigate_article_push"] }
      }
    ]
  }
];
const EMPTY_PUSH_NOTIFICATION_VALUE = {
  kicker: "",
  headline: "",
  channel: [],
  brand: "",
  contentUuid: "",
  breakingNewsFlag: false
};
const EMPTY_NEWS_BANNER = { headline: "" };
const ARTICLE_PUSH_BRAND_WHITE_LIST = ["bunte", "focus"];
const ARTICLE_PUSH_BRAND_CONFIG = {
  bunte: {
    kicker: {
      maxPerfectLength: 40,
      maxLength: 40
    },
    headline: {
      maxPerfectLength: 38,
      maxLength: 38
    }
  },
  focus: {
    headline: {
      maxPerfectLength: 80,
      maxLength: 100
    }
  }
};
const entityEndpoint = "article-push";
const ArticlePushService = registerEntityEndpoint(entityEndpoint);
const { getEntity, listEntities, postEntity, deleteEntity } = ArticlePushService;
const getArticlePush = async (id) => {
  return getEntity(id);
};
const postArticlePush = async (articlePush) => {
  return postEntity(articlePush);
};
const putArticlePush = async (articlePush) => {
  return articlePush;
};
const getPushChannels = async (brand) => {
  return (await getClient().get(`cms/article-push/channels/${brand}`)).data;
};
const fetchArticlesLastPush = async (contentUuid) => {
  return (await getClient().get(`cms/article-push/last-push/${contentUuid}`)).data;
};
const getChannel = async (id) => {
  return (await getClient().get(`/cms/channels/${id}`)).data;
};
const getContentWorkflowUrl = (contentUuid) => `cms/contents/${contentUuid}/workflow`;
const getContentWorkflowBannerUrl = (brand) => `cms/contents/banners/${brand}/active`;
const getContentWorkflow = async (contentUuid) => {
  return (await getClient().get(getContentWorkflowUrl(contentUuid))).data;
};
const getContentWorkflowOfActiveBanners = async (brand) => {
  return (await getClient().get(getContentWorkflowBannerUrl(brand))).data;
};
const createContentWorkflow = async ({ contentUuid, data }) => {
  return (await getClient().post(getContentWorkflowUrl(contentUuid), data)).data;
};
const partialUpdateContentWorkflow = async ({
  contentUuid,
  data
}) => {
  return (await getClient().patch(getContentWorkflowUrl(contentUuid), data)).data;
};
const getEmptyArticlePush = () => ({
  kicker: "",
  headline: "",
  brand: "bunte",
  contentUuid: "",
  channel: []
});
const getEmptyBannerTabContext = () => {
  return {
    newsBanner: { ...EMPTY_NEWS_BANNER },
    contentWorkflow: null,
    requestedActivationDuration: void 0,
    isBannerDataLoading: false,
    isBannerUpdating: false,
    activeBannersWorkflows: []
  };
};
const isArticlePushWhitelistBrand = (brand) => brand ? ARTICLE_PUSH_BRAND_WHITE_LIST.includes(brand) : false;
const createUpdateBanner = async (contentUuid, hasContentWorkflow, bannerData) => {
  const serverResponse = await (hasContentWorkflow ? partialUpdateContentWorkflow : createContentWorkflow)({
    contentUuid,
    data: {
      newsBanner: { ...bannerData }
    }
  });
  return serverResponse;
};
const fetchBannerData = async (article, bannerContext) => {
  bannerContext.isBannerDataLoading = true;
  bannerContext.requestedActivationDuration = void 0;
  bannerContext.contentWorkflow = null;
  bannerContext.activeBannersWorkflows = [];
  const defaultHeadline = (article == null ? void 0 : article.kicker) ? `${article == null ? void 0 : article.kicker} - ${article == null ? void 0 : article.title}` : (article == null ? void 0 : article.title) ?? "";
  bannerContext.newsBanner = { ...EMPTY_NEWS_BANNER, headline: defaultHeadline };
  if (!(article == null ? void 0 : article._id)) {
    bannerContext.isBannerDataLoading = false;
    return;
  }
  try {
    const [workflowOfCurrentArticle, activeBannersWorkflowsResponse] = await Promise.all([
      getContentWorkflow(article._id),
      getContentWorkflowOfActiveBanners(article.brand)
    ]);
    if (workflowOfCurrentArticle) {
      bannerContext.contentWorkflow = workflowOfCurrentArticle;
    }
    bannerContext.activeBannersWorkflows = [...activeBannersWorkflowsResponse];
    if (workflowOfCurrentArticle == null ? void 0 : workflowOfCurrentArticle.newsBanner) {
      bannerContext.newsBanner = {
        ...workflowOfCurrentArticle.newsBanner
      };
    }
  } finally {
    bannerContext.isBannerDataLoading = false;
  }
};
const handleBannerSave = async (action, article, bannerForm, bannerContext, options) => {
  await nextTick(async () => {
    var _a, _b;
    const isValid = await (bannerForm == null ? void 0 : bannerForm.validate(true));
    let contentUuid;
    if (!isValid || !(article == null ? void 0 : article.brand)) {
      options.bannerFieldsAction();
      return;
    }
    try {
      bannerContext.isBannerUpdating = true;
      const saveActionRes = await ((_a = options.onSaveAction) == null ? void 0 : _a.call(options, false));
      contentUuid = (saveActionRes == null ? void 0 : saveActionRes.contentUuid) || (article == null ? void 0 : article._id);
      if (!contentUuid) {
        options.bannerFieldsAction();
        return;
      }
      const showUntilDate = new Date(Date.now() + (bannerContext.requestedActivationDuration ?? 30) * 60 * 1e3);
      const serverResponse = await createUpdateBanner(contentUuid, !!bannerContext.contentWorkflow, {
        ...bannerContext.newsBanner,
        showUntilDate
      });
      bannerContext.activeBannersWorkflows = [...await getContentWorkflowOfActiveBanners(article.brand)];
      bannerContext.contentWorkflow = serverResponse;
      bannerContext.newsBanner = {
        ...serverResponse.newsBanner ? serverResponse.newsBanner : EMPTY_NEWS_BANNER
      };
    } finally {
      bannerContext.requestedActivationDuration = void 0;
      bannerContext.isBannerUpdating = false;
      options.closeAction();
      if (action === "publish" && contentUuid) {
        (_b = options.onPushDoneAction) == null ? void 0 : _b.call(options, contentUuid);
      }
    }
  });
};
const handleBannerStop = async (article, bannerContext, options) => {
  await nextTick(async () => {
    var _a;
    if (!(article == null ? void 0 : article._id) || !((_a = bannerContext.contentWorkflow) == null ? void 0 : _a.newsBanner)) {
      options.bannerFieldsAction();
      return;
    }
    try {
      bannerContext.isBannerUpdating = true;
      const serverResponse = await createUpdateBanner(article._id, !!bannerContext.contentWorkflow, {
        ...bannerContext.contentWorkflow.newsBanner,
        showUntilDate: /* @__PURE__ */ new Date()
      });
      bannerContext.activeBannersWorkflows = [...await getContentWorkflowOfActiveBanners(article.brand)];
      bannerContext.newsBanner = {
        ...serverResponse.newsBanner ? serverResponse.newsBanner : EMPTY_NEWS_BANNER
      };
    } finally {
      bannerContext.isBannerUpdating = false;
      options.closeAction();
    }
  });
};
const ArticlePushModal = defineAsyncComponent(() => import("./article-push-modal-BIChP6Xo.js"));
const ArticlePushActionButton = defineAsyncComponent(() => import("./article-push-action-button-crc11254.js"));
const articlePushModule = {
  messages,
  routes,
  contentBlocks: []
};
export {
  ARTICLE_PUSH_BRAND_CONFIG as A,
  EMPTY_PUSH_NOTIFICATION_VALUE as E,
  getChannel as a,
  getEmptyBannerTabContext as b,
  fetchBannerData as c,
  getContentWorkflow as d,
  createUpdateBanner as e,
  fetchArticlesLastPush as f,
  getPushChannels as g,
  handleBannerStop as h,
  handleBannerSave as i,
  isArticlePushWhitelistBrand as j,
  ArticlePushModal as k,
  ArticlePushService as l,
  getEmptyArticlePush as m,
  getArticlePush as n,
  putArticlePush as o,
  postArticlePush as p,
  ArticlePushActionButton as q,
  articlePushModule as r,
  ARTICLE_PUSH_ROUTE as s,
  ARTICLE_PUSH_BRAND_WHITE_LIST as t
};
//# sourceMappingURL=index-AbPn0PJz.js.map
